module.exports = __webpack_public_path__ + "img/bgtop-news.284af697.jpg";